"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var removeHexPrefix = function removeHexPrefix(str) {
  return (str || '').replace(/^0x/, '');
};

exports.default = removeHexPrefix;